import { render, staticRenderFns } from "./PointInfo.vue?vue&type=template&id=e27c4ed0&scoped=true&"
import script from "./PointInfo.vue?vue&type=script&lang=js&"
export * from "./PointInfo.vue?vue&type=script&lang=js&"
import style0 from "./PointInfo.vue?vue&type=style&index=0&id=e27c4ed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27c4ed0",
  null
  
)

export default component.exports